/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import OneClickButton from '../../../../components/form/button';
import addNotification from '../../../../components/notification';
import {
  Panel, PanelBody, PanelFooter, PanelHeader,
} from '../../../../components/panel/panel';

import { getBranchesOptions } from '../../../../app/store/actions/branches';
import { printLotLabels } from '../../../../app/store/actions/labels';
import { generateLots, getLotInfo, getOptionsLots } from '../../../../app/store/actions/lots';
import FormatHelpers from '../../../../helpers/format';

import WikiHelp from '../../../../components/tooltip/wikiHelp';
import ROUTES from '../../../../config/routes';
import Form from '../../../../components/form/form';

class LotForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      branchCode: '',
      branchName: '',
      initial: '',
      prefix: 'L',
      lastLot: 0,
      quantity: 1,
      showPrintDialog: false,
      printStart: 0,
      printEnd: 0,
      showPrinterDialog: false,
      printerOptions: [],
      lots: [],
      printerSelected: null,
      label: '< >',
    };
  }

  async componentDidMount() {
    this.getLotInfo();
  }

  getLotInfo = async () => {
    const lotInfo = await this.props.getLotInfo();
    const {
      branchCode, branchName, lastLot, userPrinter, printerOptions,
    } = lotInfo;
    const { printerSelected } = this.state;

    const listBranch = !!branchCode && !!branchName ? null : await this.props.getBranchesOptions();

    this.setState({
      listBranch,
      branch: listBranch ? listBranch[0].value : null,
      branchCode,
      branchName,
      lastLot,
      printerOptions,
      printerSelected: printerSelected === null
        ? userPrinter
        : printerSelected !== userPrinter
          ? printerSelected
          : userPrinter,
    });
  };

  createSelectPrint = (value, attr, label, items) => (
    <div className="form-group p-2">
      <label>{label}</label>
      <select
        className="form-control"
        value={value || ''}
        onChange={(e) => this.setValue(attr, e.target.value)}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
    </div>
  );

  setValue = async (attr, value) => {
    if (attr === 'initial' || attr === 'prefix') {
      const regex = /^[A-Za-z0-9]{0,5}$/;

      if (!regex.test(value)) return;

      await this.setState({
        [`${attr}`]: value,
      });
    } else if (attr === 'quantity') {
      await this.setState({
        [`${attr}`]: FormatHelpers.formatNumber(value, 0, false, true),
      });
    } else if (attr === 'printEnd') {
      await this.setState({
        printStart: value,
        printEnd: value,
      });
    } else {
      await this.setState({
        [`${attr}`]: value,
      });
    }
  };

  generateLots = async () => {
    const {
      branchCode, quantity, initial, prefix,
    } = this.state;

    try {
      const result = await this.props.generateLots(branchCode, parseInt(quantity, 10), initial, prefix);
      await this.getLotInfo();

      const firstBap = result[0].code;
      const lastBap = result[result.length - 1].code;
      this.setState({
        showPrintConfirmation: false,
        printStart: firstBap,
        printEnd: lastBap,
        lots: result,
      });
      this.printLot();
    } catch (error) {
      addNotification(
        'danger',
        I18n.t('BEE1387' /* Gerar Lote */),
        I18n.t('BEE1413' /* Erro ao gerar Lote! */),
        'top-right',
      );
    }
  };

  showReprintDialog = async () => {
    const { lastLot, branchCode, label } = this.state;
    const lots = await this.props.getOptionsLots(branchCode, label);

    this.setState({
      showPrintDialog: true,
      printStart: lastLot,
      printEnd: lastLot,
      lots,
    });
  };

  hidePrintDialog = () => {
    const { lastLot } = this.state;
    this.setState({
      showPrintDialog: false,
      printStart: lastLot,
      printEnd: lastLot,
    });
  };

  printLot = async () => {
    const { printerOptions } = this.state;

    if (!printerOptions || printerOptions.length === 0) {
      addNotification(
        'danger',
        I18n.t('BEE1414', { 0: I18n.t('BEE428' /* Lote */).toUpperCase() } /* Impressão %{0} */),
        I18n.t('BEE1415' /* Usuário não possui impressora relacionada */),
        'top-right',
      );
    } else if (printerOptions && printerOptions.length > 1) {
      this.setState({
        showPrinterDialog: true,
        showPrintDialog: false,
      });
    } else {
      await this.printLotLabels();
    }
  };

  printLotLabels = async () => {
    const {
      lots, printStart, printEnd, printerSelected, initial, printerOptions, prefix,
    } = this.state;
    let codeInit = `${prefix}${printStart}${initial}`;
    let codeEnd = `${prefix}${printEnd}${initial}`;

    const filteredLots = lots.filter((lot) => lot.code >= printStart && lot.code <= printEnd);
    codeInit = `${filteredLots[0].prefix}${printStart}${filteredLots[0].initial}`;
    // eslint-disable-next-line max-len
    codeEnd = `${filteredLots[filteredLots.length - 1].prefix}${printEnd}${filteredLots[filteredLots.length - 1].initial}`;
    await this.props.printLotLabels((filteredLots.length)
      ? filteredLots : lots, printerSelected || printerOptions[0].value);

    // this.getLotInfo();
    if (codeInit !== codeEnd) {
      addNotification(
        'success',
        I18n.t('BEE1414', { 0: I18n.t('BEE428' /* Lote */).toUpperCase() } /* Impressão %{0} */),
        I18n.t('BEE1416', {
          0: codeInit,
          1: codeEnd,
          2: (printerSelected) || printerOptions[0].value,
        } /* Imprimindo etiquetas %{0} a %{1} na impressora %{2} */),
        'top-right',
      );
    } else {
      addNotification(
        'success',
        I18n.t('BEE1414', { 0: I18n.t('BEE428' /* Lote */).toUpperCase() } /* Impressão %{0} */),
        I18n.t('BEE4522', {
          0: codeInit,
          1: (printerSelected) || printerOptions[0].value,
        } /* Imprimindo etiqueta %{0} na impressora %{1}. */),
        'top-right',
      );
    }

    this.setState({
      showPrinterDialog: false,
      showPrintDialog: false,
      initial: '',
      prefix: 'L',
      quantity: 1,
    });
  };

  hidePrinterDialog = () => {
    this.setState({
      showPrinterDialog: false,
    });
  };

  printConfirmation = () => {
    if (!parseInt(this.state.quantity, 10)) {
      addNotification(
        'danger',
        I18n.t('BEE1380' /* Etiqueta Lote */),
        I18n.t('BEE2293' /* A quantidade tem que ser maior que 0 */),
        'top-right',
      );
    } else if (parseInt(this.state.quantity, 10) === 1) this.generateLots();
    else this.setState({ showPrintConfirmation: true });
  };

  render() {
    const {
      branchCode, branchName, lastLot, quantity, initial, prefix, showPrintDialog,
      showPrinterDialog, printEnd,
      printerOptions, printerSelected, branch, listBranch, lots, showPrintConfirmation,
    } = this.state;

    const branchLabel = !!branchCode && !!branchName ? `${branchCode} - ${branchName}` : '';
    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE1371' /* Etiquetas */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE1380' /* Etiqueta Lote */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {I18n.t('BEE1380' /* Etiqueta Lote */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.MOVEMENT_LABEL_LOT_HELP} />
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form>
              <Panel>
                <PanelHeader noButton />
                <PanelBody>
                  {/* {(branchLabel
                    ? this.createInput(
                      branchLabel,
                      'branchLabel',
                      I18n.t('BEE145'),
                      '',
                      'text',
                      true,
                      true,
                    )
                    : this.createSelect(branch, 'branch', `${I18n.t('BEE145')}:`, listBranch || [])
                  )}
                  {this.createInput(
                    lastLot,
                    'lastLot',
                    I18n.t('BEE1385' ),
                    '',
                    'number',
                    true,
                    true,
                  )}
                  {this.createInput(
                    initial,
                    'initial',
                    I18n.t('BEE1384'),
                    '',
                    'text',
                    false,
                    false,
                  )}
                  {this.createInput(
                    FormatHelpers.formatNumber(quantity, 0, false, true),
                    'quantity',
                    I18n.t('BEE1267' ),
                    '',
                    'number',
                    false,
                    false,
                    2,
                  )} */}

                  <Form
                    noPanel
                    setValue={this.setValue}
                    setValueDrop={this.setValueDrop}
                    inputs={(formContext) => ([
                      branchLabel
                        ? formContext.createInput(
                          branchLabel,
                          'branchLabel',
                          `${I18n.t('BEE145' /* Filial */)}:`,
                          '',
                          'text',
                          true,
                          true,
                        )
                        : formContext.createSelect(
                          branch,
                          'branch',
                          `${I18n.t('BEE145' /* Filial */)}:`,
                          listBranch || [],
                          false,
                          undefined,
                          undefined,
                          undefined,
                          true,
                        ),
                      formContext.createInput(
                        lastLot,
                        'lastLot',
                        `${I18n.t('BEE1385' /* Última Sequência de Lote Gerada */)}:`,
                        '',
                        'number',
                        true,
                        true,
                      ),
                      formContext.createInput(
                        prefix,
                        'prefix',
                        `${I18n.t('BEE4839' /* Prefixo */)}:`,
                        I18n.t('BEE2991' /* Informe o prefixo */),
                        'text',
                        false,
                        false,
                      ),
                      formContext.createInput(
                        initial,
                        'initial',
                        `${I18n.t('BEE4840' /* Sufixo (Sigla) */)}:`,
                        I18n.t('BEE3729' /* Informe a sigla */),
                        'text',
                        false,
                        false,
                      ),
                      formContext.createInput(
                        FormatHelpers.formatNumber(quantity, 0, false, true),
                        'quantity',
                        `${I18n.t('BEE1267' /* Quantidade a gerar */)}:`,
                        '',
                        'number',
                        true,
                        false,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        2,
                      ),
                    ])}
                  />

                </PanelBody>
                <PanelFooter>
                  <OneClickButton
                    type="button"
                    className="btn btn-120 btn-white p-5 m-5"
                    onClick={() => this.showReprintDialog()}
                  >
                    { I18n.t('BEE1269' /* Reimprimir */)}

                  </OneClickButton>
                  <OneClickButton
                    type="button"
                    className="btn btn-120 btn-primary p-5 m-5"
                    onClick={() => this.printConfirmation()}
                  >
                    {I18n.t('BEE1387' /* Gerar Lote */)}

                  </OneClickButton>
                </PanelFooter>
              </Panel>
            </form>
            {(showPrintDialog && (
            <SweetAlert
              info
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE1270' /* Imrpimir */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE1269' /* Reimprimir */)}
              onConfirm={() => this.printLot()}
              onCancel={() => this.hidePrintDialog()}
              style={{ width: '300px !important' }}
            >
              <div style={{ width: 600 }}>
                {this.createSelectPrint(
                  printEnd,
                  'printEnd',
                  I18n.t('BEE428' /* Lote */),
                  lots,
                )}
              </div>
            </SweetAlert>
            ))}
            {(showPrinterDialog && (
            <SweetAlert
              confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE1324' /* Selecionar Impressora */)}
              onConfirm={() => this.printLotLabels()}
              onCancel={() => this.hidePrinterDialog()}
            >
              {this.createSelectPrint(
                printerSelected,
                'printerSelected',
                I18n.t('BEE328' /* Impressora */),
                printerOptions,
              )}
            </SweetAlert>
            ))}
            {(showPrintConfirmation && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText={I18n.t('BEE1800' /* Prosseguir */)}
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="danger"
              title={I18n.t('BEE1975' /* Verificação de Quantidade */)}
              onConfirm={() => this.generateLots()}
              onCancel={() => this.setState({ showPrintConfirmation: false })}
            >
              <h5>
                {I18n.t('BEE1974', { 0: quantity } /* A quantidade informada é %{0}. Deseja prosseguir? */)}
              </h5>
            </SweetAlert>
            )
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getLotInfo: () => dispatch(getLotInfo()),
  getOptionsLots: (branchCode) => dispatch(getOptionsLots(branchCode)),
  generateLots: (branchCode, quantity, initial, prefix) => dispatch(
    generateLots(branchCode, quantity, initial, prefix),
  ),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  printLotLabels: (lots, printerSelected) => dispatch(printLotLabels(lots, printerSelected)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LotForm));
